import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import axios from "axios";
import { set, isEmpty, get } from "lodash";
import { datadogRum } from "@datadog/browser-rum";
import { getCookies, getUrlAuthToken } from ".";
import servicesUtils from "./servicesUtils";
import redirectToLogin from "./redirectToLogin";
import constants from "./constants";
var TIMEOUT = 180000;
var MAX_RETRIES = 3;
var RETRY_DELAY = 1000;
var axiosConnect = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  timeout: TIMEOUT,
  withCredentials: true
  // exposedHeaders: ["set-cookie"] // there is no such key called exposedHeaders in type AxiosRequestConfig
});

axiosConnect.interceptors.request.use( /*#__PURE__*/function () {
  var _interceptorFunc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
    var _cookies, _csrfToken, qXRProjectURLs, baseURL, url, params, isUserInfoCall, urlAuthToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (config.method === "post" || config.method === "patch" || config.method === "put" || config.method === "delete") {
              _cookies = getCookies();
              _csrfToken = get(_cookies, ["csrftoken"], "");
              if (_csrfToken) {
                set(config, ["headers", servicesUtils.X_CSRF], _csrfToken);
              }
            }
            qXRProjectURLs = ["/auth/", "/login/", "/logout/", "/csrf/"];
            if (config.url && qXRProjectURLs.indexOf(config.url) === -1) {
              set(config, ["url"], "".concat(config.url));
            }
            baseURL = config.baseURL, url = config.url, params = config.params;
            isUserInfoCall = (url === null || url === void 0 ? void 0 : url.includes("/userinfo")) || (url === null || url === void 0 ? void 0 : url.includes("/profile"));
            urlAuthToken = getUrlAuthToken();
            if (urlAuthToken && !isUserInfoCall && params) {
              params["url_auth_token"] = urlAuthToken;
            }
            if (!isEmpty(baseURL)) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", Promise.reject({
              noValidUrl: true
            }));
          case 9:
            return _context.abrupt("return", config);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  function interceptorFunc(_x) {
    return _interceptorFunc.apply(this, arguments);
  }
  return interceptorFunc;
}());
axiosConnect.interceptors.response.use(function (response) {
  return Promise.resolve(response);
}, function (err) {
  var errorStatus = get(err, ["response", "status"]);
  var url = get(err, ["config", "url"], "");
  var config = get(err, "config", {});
  var isUserInfoCall = get(err, ["config", "url"], "").includes("/userinfo");
  var stopRedirectLogin = get(err, ["config", "params", "stopRedirectLogin"], false);
  var isUrlAuthToken = !!getUrlAuthToken();
  var code = err.code,
    message = err.message;
  // if ([400, 403, 404, 500, 502, 503, 504].indexOf(errorStatus) !== -1) {
  //   // log 4xx, 5xx errors, not logging 401
  //   SentryIntegration.logError(err)
  // }

  if (code === "ECONNABORTED" || message.includes("timeout")) {
    var _maxRetries = config.maxRetries || MAX_RETRIES;
    var _retryCount = config.retryCount || 0;
    if (_retryCount < _maxRetries) {
      _retryCount++;
      return new Promise(function (resolve) {
        setTimeout(function () {
          return resolve(axiosConnect(_objectSpread(_objectSpread({}, config), {}, {
            retryCount: _retryCount
          })));
        }, config.retryDelay || RETRY_DELAY);
      });
    }
  }
  if (errorStatus === 401 && !stopRedirectLogin && window.location.pathname !== "/landing-page" && window.location.pathname !== "/notifications-widget" && window.location.pathname !== "/auth/login" && !isUrlAuthToken) {
    var _redirectLogin = localStorage.getItem("redirectLogin");
    if (_redirectLogin) {
      localStorage.removeItem("redirectLogin");
      redirectToLogin();
    } else {
      var _window;
      // The original URL the user came from
      var _redirectURL = window.location.pathname;
      (_window = window) === null || _window === void 0 || (_window = _window.localStorage) === null || _window === void 0 ? void 0 : _window.setItem(constants.PERSISTED.redirectAfterLogin, _redirectURL);
      window.location.href = window.location.origin + "/landing-page";
    }
  } else {
    /* eslint-disable no-console */
    console.error("Invalid request", err);
    if (process.env.NEXT_PUBLIC_APP_ENV === "production" && window.location.pathname !== "/landing-page") {
      var _error = new Error("XHR Error - ".concat(errorStatus), {
        cause: err
      });
      datadogRum.addError(_error, {
        scope: "xhr-error",
        url: url
      });
    }
  }
  return Promise.reject(err);
});
export default axiosConnect;